<template>
  <TrialNoticeDialog
    :visible.sync="visible"
    mode="expire"
    :config="trialConfig"
    :remain-days="remainDays"
    @confirm="onConfirm"
  />
</template>

<script>
import TrialNoticeDialog from '@/components/TrialNoticeDialog.vue'
import { markRemindShown, prepareTrialExpireRemind } from '@/utils/trial'

export default {
  name: 'TrialExpireRemindHost',
  components: {
    TrialNoticeDialog,
  },
  props: {
    pageKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      trialConfig: {},
      remainDays: null,
      userId: null,
    }
  },
  mounted() {
    this.checkRemind()
  },
  methods: {
    async checkRemind() {
      const result = await prepareTrialExpireRemind(this.$api, this.pageKey)
      if (!result) return
      this.trialConfig = result.trialConfig
      this.remainDays = result.remainDays
      this.userId = result.userId
      this.visible = true
    },
    onConfirm() {
      markRemindShown(
        this.userId || localStorage.getItem('userId'),
        this.pageKey
      )
      this.visible = false
    },
  },
}
</script>
